module.exports = __webpack_public_path__ + "img/Group 97804.86f60828.png";